import { GridView, Search } from '@mui/icons-material'
import type { ReactElement } from 'react'

import entityIcons from '~/components/icons/entityIcons'

import type { SearchCategory } from './types'

export const categoryIcons: Record<SearchCategory, ReactElement> = {
  site: entityIcons.site,
  charger: entityIcons.charger,
  vehicle: entityIcons.vehicle,
  user: entityIcons.user,
  org: entityIcons.organization,
  synoplink: entityIcons.synopLink,
  solarArray: entityIcons.solarArray,
  page: <GridView fontSize="small" />
}

export const searchIcon = <Search />
